/**
 * @typedef {Object} StageDO
 * @property {number} stageNumber - The stage number
 * @property {number} lowerStageNumber - The lower stage number
 * @property {number} upperStageNumber - The upper stage number
 * @property {boolean} lowerVisible - Whether the lower stage is visible
 * @property {boolean} upperVisible - Whether the upper stage is visible
 */

import {
  TOOTH_GUM_TYPE,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";

/**
 * @type {StageDO[]}
 */
let stageDOListSingle = [];
let stageNumberDOMapSingle = {};

const setStageDOList = (stageDOList) => {
  stageDOListSingle = stageDOList;
  for (const stageDO of stageDOList) {
    const { stageNumber } = stageDO;
    stageNumberDOMapSingle[`${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`] =
      stageDO;
  }
};

const getStageDOList = () => {
  return stageDOListSingle;
};

const getStageDOFromStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`;
  const stageDO = stageNumberDOMapSingle[key];

  if (toothGumType === TOOTH_GUM_TYPE.UPPER) {
    const { upperStageNumber, upperVisible, stageNumber } = stageDO;
    return {
      visible: upperVisible,
      stageNumber: stageNumber,
      activeStageNumber: upperStageNumber,
    };
  }

  if (toothGumType === TOOTH_GUM_TYPE.LOWER) {
    const { lowerStageNumber, lowerVisible, stageNumber } = stageDO;
    return {
      visible: lowerVisible,
      stageNumber: stageNumber,
      activeStageNumber: lowerStageNumber,
    };
  }

  return null;
};

const getStageDOListByToothGumType = (toothGumType) => {
  if (toothGumType === TOOTH_GUM_TYPE.LOWER) {
    return stageDOListSingle.map((stageDO) => {
      const { lowerStageNumber, lowerVisible, stageNumber } = stageDO;
      return {
        visible: lowerVisible,
        stageNumber: stageNumber,
        activeStageNumber: lowerStageNumber,
      };
    });
  }

  if (toothGumType === TOOTH_GUM_TYPE.UPPER) {
    return stageDOListSingle.map((stageDO) => {
      const { upperStageNumber, upperVisible, stageNumber } = stageDO;
      return {
        visible: upperVisible,
        stageNumber: stageNumber,
        activeStageNumber: upperStageNumber,
      };
    });
  }
};

const getLastStageDO = () => {
  if (stageDOListSingle.length === 0) {
    return null;
  }

  return stageDOListSingle[stageDOListSingle.length - 1];
};

export default {
  setStageDOList,
  getLastStageDO,
  getStageDOList,
  getStageDOListByToothGumType,
  getStageDOFromStageNumberAndToothGumType
};
